export default "__VITE_ASSET__B8hH9LJ6__"